class StickyButton extends HTMLElement {
  constructor() {
    super();
    this.state = 'natural'; // 'bottom' | 'natural' | 'top'
    this.placeholder = null;
    this.triggerOffset = 60;
    this.mobileBreakpoint = 768;
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.triggerOffset =
      parseInt(this.getAttribute('data-trigger-offset')) || 60;

    this.placeholder = document.createElement('div');
    this.placeholder.style.display = 'none';
    this.parentNode.insertBefore(this.placeholder, this);

    const handler = () => this.checkScroll();
    window.addEventListener('scroll', handler, { passive: true, signal });
    window.addEventListener('resize', handler, { passive: true, signal });

    this.checkScroll();
  }

  disconnectedCallback() {
    if (this.abortController) this.abortController.abort();

    if (this.placeholder && this.placeholder.parentNode) {
      this.placeholder.parentNode.removeChild(this.placeholder);
    }
  }

  getOriginalRect() {
    return this.placeholder.style.display !== 'none'
      ? this.placeholder.getBoundingClientRect()
      : this.getBoundingClientRect();
  }

  checkScroll() {
    if (window.innerWidth >= this.mobileBreakpoint) {
      if (this.state !== 'natural') this.applyNatural();
      return;
    }

    const rect = this.getOriginalRect();
    const viewportHeight = window.innerHeight;

    // Button's natural position is below the viewport → stick to bottom
    if (rect.top + 60 > viewportHeight) {
      if (this.state !== 'bottom') this.applyBottom();
    }
    // Button's natural position is above the trigger offset → stick to top
    else if (rect.top < this.triggerOffset) {
      if (this.state !== 'top') this.applyTop();
    }
    // Button is visible in viewport → natural position
    else {
      if (this.state !== 'natural') this.applyNatural();
    }
  }

  applyBottom() {
    this.showPlaceholder();
    this.style.position = 'fixed';
    this.style.top = '';
    this.style.bottom = '0';
    this.style.left = '0';
    this.style.right = '0';
    this.style.backgroundColor = 'white';
    this.style.padding = '10px 20px';
    this.style.zIndex = '50';
    this.style.width = '100%';
    this.style.boxSizing = 'border-box';
    this.state = 'bottom';
    this.style.border = 'none';
    this.style.boxShadow = '0 8px 0 8px white';
  }

  applyTop() {
    this.showPlaceholder();
    this.style.position = 'fixed';
    this.style.bottom = '';
    this.style.top = this.triggerOffset + 'px';
    this.style.left = '0';
    this.style.right = '0';
    this.style.backgroundColor = 'white';
    this.style.padding = '0 20px 0';
    this.style.zIndex = '50';
    this.style.width = '100%';
    this.style.boxSizing = 'border-box';
    this.state = 'top';
    this.style.border = 'none';
    this.style.boxShadow = '0 8px 0 8px white';
  }

  applyNatural() {
    this.placeholder.style.display = 'none';
    this.placeholder.style.height = '';
    this.style.position = '';
    this.style.top = '';
    this.style.bottom = '';
    this.style.left = '';
    this.style.right = '';
    this.style.backgroundColor = '';
    this.style.padding = '';
    this.style.zIndex = '';
    this.style.width = '';
    this.style.boxSizing = '';
    this.state = 'natural';
    this.style.border = 'none';
    this.style.boxShadow = '0 8px 0 8px white';
  }

  showPlaceholder() {
    if (this.placeholder.style.display === 'none') {
      const height = this.offsetHeight;
      this.placeholder.style.display = 'block';
      this.placeholder.style.height = height + 'px';
    }
  }
}

if (!customElements.get('sticky-button')) {
  customElements.define('sticky-button', StickyButton);
}
